// ===========================================================================
// What to tell somebody waiting on a person to look at their age check.
//
// Half of every check lands on a human, and the human sleeps. Somebody
// arriving at three in the morning read "a person is double-checking your age,
// this can take a while", waited, and left -- the operator's own account of
// why most people who tried never got in. The queue was never the problem.
// The silence was.
//
// The rule, in his words: "chat with admin" is the overall key. While that is
// on, none of this is said -- a way to reach a person sits right there in the
// chat, and telling somebody nobody is around contradicts an open door. With
// it off the clock speaks: inside the hours somebody is reviewing, outside
// them here is when they will be.
//
// Its own module, with no imports, so it can be tested. Everything else in
// age.js reaches Vite-only config and cannot be loaded under plain node.
// ASCII only.
// ===========================================================================

/** Said in every version: the part that makes a wait something you can leave. */
const KEEP = 'Your place is held and you will not need a new photo, so you can close this page and come back.';

/**
 * @param {{ reviewing?: boolean, reviewNext?: string|null }} [state] as the
 *   server sent it. Absent fields mean "nothing to say about hours", which is
 *   what admin chat being on looks like from here.
 * @returns {string}
 */
export function waitingLine({ reviewing, reviewNext } = {}) {
  if (reviewing === false && reviewNext) {
    const when = new Date(reviewNext);
    if (!Number.isNaN(when.getTime())) {
      // Their clock, not the server's: a person reads "8am" and knows it.
      const at = when.toLocaleString(undefined, { hour: 'numeric', minute: '2-digit', weekday: 'short' });
      return `Nobody is reviewing right now. The next check is around ${at}. ${KEEP}`;
    }
  }
  if (reviewing === true) return `A person is reviewing now, so this should not be long. ${KEEP}`;
  return `A person is double-checking your age. This can take a while. ${KEEP}`;
}

export default { waitingLine };
